import React from 'react';
import { Menu } from 'antd';
import { useSetSelectedParam } from '../../model/modalParam';
import { useSetModalVisible } from '../../model/modelState';
import { params } from '../../constants';

const paramUpdater = (value) => (prev) => prev?.id === value.id ? prev : value;

const ParamsMenu = ({ onClick, ...props }) => {
  const setSelectedParam = useSetSelectedParam();
  const setModalVisible = useSetModalVisible();

  const handleMenuClick = ({ item }) => {
    setSelectedParam(paramUpdater(item.props.value));
    setModalVisible(true);
    onClick();
  };

  return (
    <Menu
      {...props}
      onClick={handleMenuClick}
    >
      {params.map((param) => (
        <Menu.Item
          key={param.id}
          value={param}
        >
          {param.name}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default ParamsMenu;
